// extracted by css-extract-rspack-plugin
export default {"cls1":"SavedReferencesModal-cls1_jlv","cls2":"SavedReferencesModal-cls2_3LM SavedReferencesModal-cls1_jlv"};